import {
  ListTagsRequest,
  ListTagsResponse,
} from 'client/@types/cbinsights/cbitagservice/cbitagservice';
import { UseQueryResult, useQuery } from 'react-query';
import { listTags } from '../api/ListTags';

export enum TagServicesKeys {
  ListTags = 'ListTags',
  GetTagEntities = 'GetTagEntities',
}

export const useListTags = ({
  enabled = false,
  request,
}: {
  enabled: boolean;
  request: Partial<ListTagsRequest>;
}): UseQueryResult<Partial<ListTagsResponse>, Error> =>
  useQuery<
    ListTagsResponse,
    Error,
    ListTagsResponse,
    [TagServicesKeys, Partial<ListTagsRequest>]
  >([TagServicesKeys.ListTags, request], () => listTags(request), {
    notifyOnChangeProps: ['data', 'isFetching', 'isFetchedAfterMount'],
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    enabled,
  });
